import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import { MontageCreatePayload, MontageMeta } from '@/modules/Logistics/interfaces/LogisticsInterfaces';

/**
 * MontageListAPI - API controller for montage lists
 */
export default class MontageListAPI {
    public static async getAll(): Promise<AxiosResponse> {
        try {
            const response = await ApiController.get(ApiRoutes.montageLists.getAll);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async getById(id: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.get(ApiRoutes.montageLists.getById(id));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async getPdf(id: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.get(ApiRoutes.montageLists.getPdf(id), null, true);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async create(payload: MontageCreatePayload): Promise<AxiosResponse> {
        const request = {
            data: payload.data,
            meta: payload.meta,
        };

        try {
            const response = await ApiController.post(ApiRoutes.montageLists.create, request);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async update(id: string, payload: Partial<MontageMeta>): Promise<AxiosResponse> {
        const request = {
            data: {
                attributes: {
                    ...payload,
                },
                type: 'montage_lists',
                id,
            },
        };

        try {
            const response = await ApiController.patch(ApiRoutes.montageLists.update(id), request);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async delete(id: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.delete(ApiRoutes.montageLists.delete(id));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
